import styles from "./home.module.css";
import Navbar from "../Navbar/Navbar";
import Typewriter from "./Typewriter";

const Home = () => {
  return (
    <div id="home" className={styles.main}>
      <Navbar />
      <div className={styles.hero}>
        <h1 className="text_theme">
          Hi, I'm <span className="text-blue">Ankit</span>
        </h1>
        <div className={styles.typewriter}>
          <Typewriter />
        </div>
        <p class="student" id="student">
          A passionate Full Stack Software Developer having an experience of
          building Web applications with JavaScript / Reactjs / Nodejs / MongoDb
          and some other cool libraries and frameworks.
        </p>{" "}
        <div class="hero-btns">
          <a href="#projects" className="btn-blue_active">
            <i class="fas fa-code"></i> Projects
          </a>
          <a
            href="https://github.com/ankitkumar3443"
            className="btn-blue"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fab fa-github"></i> Github
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
